import shareInviteWidget from '@/components/social/share-invite-widget/share-invite-widget.vue';

export default {
  components: {
    shareInviteWidget,
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-dashboard-sushi/pages/sushi-invite-friends/sushi-invite-friends.js